import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
`;

export const ParaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  word-break: break-word;
`;

export const Para = styled.p`
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  margin-bottom: 5px;

  a {
    color: #0046ff;
  }
`;

export const Div = styled.div`
  font-size: 14px;
  color: #000000e0;
  font-weight: 400;
  margin-bottom: 5px;

  a {
    color: #0046ff;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000000e0;
`;
